<div class="qb-parent-container-selection qb-h-100">
  <div class="qb-header-container">
    <div class="qb-header-text-challenge">Challenge Configuration</div>
    <div class="qb-description-challenge">
      Design your challenge by choosing the perfect building blocks. Mix and
      match to craft a seamless and personalized experience that truly resonates
      with audience
    </div>
  </div>
  <div class="qb-selection-part">
    <div class="qb-selection-wrapper">
      <div class="qb-selection-container">
        <div
          class="qb-selector-wrapper"
          *ngFor="let type of typeOfChallenges"
          (click)="selectType(type.value)"
          [ngClass]="{ active: type.value == selectedChallenge }"
        >
          <div
            class="qb-selection-header-text"
            [ngClass]="{ active: type.value == selectedChallenge }"
          >
            {{ type.displayName }}
          </div>
          <div class="qb-description-challenge">
            {{ type.description }}
          </div>
        </div>
      </div>
      <!-- <div class="qb-video-wrapper">
        <video height="360" width="100%" autoplay loop [muted]="'muted'">
          <source [src]="videoUrl" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div> -->
    </div>
  </div>
  <div class="qb-button-container-challenge-selection">
    <div class="secondary-button" (click)="selectChallengeType('exit')">
        Close
    </div>
    <div class="primary-button" (click)="selectChallengeType(selectedChallenge)">
        Select Challenge
    </div>
  </div>
</div>
